import * as constants from "./constants";
import * as createjs from "createjs-module";

/**
 * オブジェクトの拡大縮小を行うスライダーを作成する
 * @param  {} bitmap
 */
export const createScalingSlider = (stage, bitmap, onSliderFunction) => {
  // スライダーの設定
  const scalingSlider = document.getElementById(
    "zoom-slider"
  ) as HTMLInputElement;

  // 倍率の最小・最大値
  // 最大はイラストの長辺がベースエリアの300%まで
  // 最小はイラストの長辺がベースエリアの50%まで
  const MinRate = 0.5;
  const MaxRate = 6.0;
  if (bitmap.getBounds().width > bitmap.getBounds().height) {
    scalingSlider.min = String(
      Number(constants.trimPageCanvasVisibleWidth / bitmap.getBounds().width) *
        MinRate
    );
  } else {
    scalingSlider.min = String(
      Number(constants.trimPageCanvasVisibleWidth / bitmap.getBounds().height) *
        MinRate
    );
  }
  scalingSlider.max = String(Number(scalingSlider.min) * MaxRate);

  // 粒度
  scalingSlider.step = "any";
  // スライダーが動いたら拡大・縮小して再描画する
  scalingSlider.addEventListener("input", function (e) {
    // 倍率変更
    bitmap.scaleX = bitmap.scaleY = (e.target as HTMLInputElement).value;
    onSliderFunction(stage, bitmap);
  });

  // 初期倍率を中間にしておく
  bitmap.scaleX = bitmap.scaleY =
    Number(scalingSlider.min) * ((MinRate + MaxRate) / 2);
  // 倍率の初期値
  scalingSlider.value = bitmap.scaleX; // scaleYと同値
};

/**
 * ベースイラストの拡大縮小を行う
 * TODO: createScalingSliderと同じ設定が多いので集約したい
 * @param  {} stage
 * @param  {} targetDisplayObject
 * @param  {} targetScale
 * @param  {} onScaleFunction
 */
export const setTrimScale = (
  stage,
  targetDisplayObject,
  targetScale,
  onScaleFunction
) => {
  const trimScale = getTrimScale(targetDisplayObject, targetScale);
  targetDisplayObject.scaleX = targetDisplayObject.scaleY = trimScale;

  // スライダーの設定
  const scalingSlider = document.getElementById(
    "zoom-slider"
  ) as HTMLInputElement;
  // 倍率の初期値
  scalingSlider.value = trimScale;

  onScaleFunction(stage, targetDisplayObject);
};

export const getTrimScale = (targetDisplayObject, targetScale) => {
  // 長辺の最大サイズによって制限
  // 直値
  let scaleMin;
  if (
    targetDisplayObject.getBounds().width >
    targetDisplayObject.getBounds().height
  ) {
    scaleMin = 750 / targetDisplayObject.getBounds().width;
  } else {
    scaleMin = 750 / targetDisplayObject.getBounds().height;
  }
  const scaleMax = scaleMin * 2;

  targetScale = Math.min(scaleMax, targetScale);
  targetScale = Math.max(scaleMin, targetScale);
  return targetScale;
};

/**
 * canvasをdataurlスキームとして書き出す
 * @param  {} stage
 */
export const getCanvasImageByDataUrl = (stage) => {
  const dataUrl = stage.canvas.toDataURL();
  return dataUrl;
};

/**
 * 当たり判定を表示されている矩形に変更する関数
 * @param  {} displayObject
 */
export const setHitArea = (displayObject) => {
  const hitAreaShape = new createjs.Shape();
  hitAreaShape.graphics
    .beginFill("#FFF")
    .drawRect(
      displayObject.getBounds().x,
      displayObject.getBounds().y,
      displayObject.getBounds().width,
      displayObject.getBounds().height
    );
  displayObject.hitArea = hitAreaShape;
};

/**
 * 基本的なMaterialデータを取得する関数
 * @param  {} displayObject
 */
export const getMaterialBaseData = (displayObject, container) => {
  const decoData = {
    type: displayObject.decoData.type,
    x: displayObject.x,
    y: displayObject.y,
    z: container.getChildIndex(displayObject),
    scale: displayObject.scaleX, // scaleYと同値の想定
    rotation: displayObject.rotation,
    src: displayObject.decoData.src,
  };
  switch (displayObject.decoData.type) {
    case constants.decoType.normalText:
      decoData["font"] = constants.defaultFont;
      break;
    case constants.decoType.monoImage:
      decoData["font"] = constants.defaultIconFont;
      break;
    case constants.decoType.outlineText:
      decoData["font"] = constants.defaultFont;
      break;
  }
  return decoData;
};
